import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";

export default function Layout({ variant = "inventory" }) {
  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar variant={variant} />
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
